<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        جستجو اسناد حمل و نقل
                    </v-card-title>

                    <v-card-text>
                        <div >
                            <form>
                                <v-row>

                                    <v-col cols="12" style="text-align: right;color: red">
                                        <span>کاربر گرامی، در صورتی که چک باکس زیر برداشته شود تاریخ در جستجو اعمال نمی شود </span>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-row form class="form-group" style="margin-top: 20px;float: left">
                                            <p class="col-form-label">
                                            </p>
                                            <div>
                                                <v-checkbox
                                                        v-model="enable_date"
                                                        dense
                                                />
                                            </div>
                                        </v-row>

                                    </v-col>
                                    <v-col cols="4">
                                        <v-row form class="form-group">
                                            <label class="col-form-label">
                                                از تاریخ
                                            </label>
                                            <div>
                                                <ThreeDatePicker
                                                        @last_focus="another_focus_select('end_date_id_date_day')"
                                                        first_id="start_date_id_"
                                                        v-model="start_date"/>
                                            </div>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-row form class="form-group">
                                            <label class="col-form-label">
                                                تا تاریخ
                                            </label>
                                            <div>
                                                <ThreeDatePicker
                                                        first_id="end_date_id_"
                                                        @last_focus="another_focus('barname_report_delivery')"


                                                        v-model="end_date"/>
                                            </div>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-btn @click="get_data" small color="primary">
                                            <v-icon>mdi-magnify</v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="2">
                                    </v-col>



                                </v-row>
                                <v-row>
                                    <v-col>

                                        <v-text-field
                                                dense
                                                label="شماره بارنامه"
                                                outlined
                                                v-on:keyup.enter="focusNext($event)"
                                                id="barname_report_delivery"
                                                v-model="selected_barname"
                                        ></v-text-field>

                                    </v-col>
                                    <v-col dir="rtl">
                                        <treeselect
                                                :matchKeys="['code']"
                                                v-model="start_selected_truck"
                                                :cacheOptions="false"
                                                :options="trucks"
                                                @select="another_focus('delivery_report_tonaje')"
                                                placeholder="جستجو کامیون"
                                                :normalizer="normalizer_load_type"
                                        />

                                    </v-col>

                                    <v-col cols="1">
                                        <v-text-field
                                                label="کیلوگرم"
                                                dense
                                                id="delivery_report_tonaje_decimal"
                                                v-on:keyup.enter="another_focus_inside('search_load_type')"

                                                outlined
                                                v-model="selected_tonaje_decimal"
                                        ></v-text-field>

                                    </v-col>
                                    <h3 style="align-self: center">
                                        /
                                    </h3>
                                    <v-col cols="1">
                                        <v-text-field
                                                dense
                                                id="delivery_report_tonaje"
                                                v-on:keyup.enter="another_focus('delivery_report_tonaje_decimal')"
                                                label="تناژ"

                                                outlined
                                                v-model="selected_tonaje"
                                        ></v-text-field>

                                    </v-col>

                                    <v-col dir="rtl">

                                        <treeselect
                                                :matchKeys="['code']"
                                                v-model="start_selected_load_type"
                                                :cacheOptions="false"
                                                :options="load_types"
                                                id="search_load_type"
                                                @select="another_focus_inside('origin_load')"

                                                placeholder="جستجو نوع جنس"
                                                :normalizer="normalizer_load_type"
                                        />

                                    </v-col>

                                    <v-col dir="rtl">

                                        <treeselect
                                                :matchKeys="['code']"
                                                v-model="start_selected_origin_load"
                                                :cacheOptions="false"
                                                id="origin_load"
                                                @select="another_focus_inside('discharge_place')"

                                                :options="origin_loads"
                                                placeholder="جستجو مبدا بارگیری"
                                                :normalizer="normalizer_origin"
                                        />

                                    </v-col>

                                    <v-col dir="rtl">

                                        <treeselect
                                                :matchKeys="['code']"
                                                v-model="start_selected_discharge_place"
                                                :cacheOptions="false"
                                                :options="discharge_places"
                                                id="discharge_place"
                                                placeholder="جستجو محل تخلیه"
                                                :normalizer="normalizer_discharge_place"
                                        />

                                    </v-col>

                                </v-row>
                                <div class="row " style="place-content: center;">
                                    <VDataTable2
                                            dense
                                            hide-default-footer
                                            disable-pagination
                                            multi-sort
                                            height="400"
                                            @contextmenu:row="open_context_menu"
                                            fixed-header
                                            class="margin-auto table-bordered"
                                            :headers="headers"
                                            :items="filtered_items"
                                    >

                                        <template v-slot:item.row_id="{item }">
                                            {{ item._row_index+1}}
                                        </template>
                                        <template v-slot:item.calculated_driver_price="{ item }">
                                            {{get_currency(parseFloat(item.calculated_driver_price).toFixed(0))}}
                                        </template>
                                        <template v-slot:item.calculated_employer_price="{ item }">
                                            {{get_currency(parseFloat(item.calculated_employer_price).toFixed(0))}}
                                        </template>

                                        <template v-slot:item.truck_type="{ item }">
                                            <td v-if="item.truck_type==1">تک</td>
                                            <td v-if="item.truck_type==2">جفت</td>
                                        </template>
                                        <template v-slot:item.operation="{ item }">
                                            <v-row>
                                                <v-col cols="6">
                                                    <v-btn title="ویرایش" @click="edit_item(item)" outlined x-small
                                                           color="warning">
                                                        <v-icon x-small color="warning">mdi-pencil</v-icon>
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-btn title="حذف" @click="delete_item_dialog(item)" outlined
                                                           x-small
                                                           color="error">
                                                        <v-icon x-small color="error">mdi-delete</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>


                                        </template>
                                      <template slot="body.append">
                                        <tr class="pink--text">
                                          <th colspan="7" class="title">جمع کل</th>
                                          <th class="title">{{ get_currency(calculate_items(filtered_items,
                                              'tonaje')) }}
                                          </th>
                                          <th class="title">{{ get_currency(calculate_items(filtered_items,
                                              'calculated_employer_price')) }}
                                          </th>
                                          <th class="title">{{ get_currency(calculate_items(filtered_items,
                                              'calculated_driver_price')) }}
                                          </th>


                                        </tr>
                                      </template>


                                    </VDataTable2>
                                </div>
                            </form>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>


        <v-menu
                v-model="open_context_menu_dialog"
                :position-x="x"
                :position-y="y"
                absolute
                offset-y
        >
            <v-list>
                <v-list-item
                >
                    <v-list-item-title @click="edit_item">ویرایش</v-list-item-title>
                </v-list-item>
                <v-list-item
                >
                    <v-list-item-title @click="delete_item_dialog">حذف</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

    </div>
</template>
<script>
    import Vue from 'vue'
    import {bus} from '../../main'
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ThreeDatePicker from "../includes/ThreeDatePicker";

    export default {
        name: 'OriginDownload',
        components: {
            Treeselect,
            ThreeDatePicker,
        },
        data() {
            return {
                x: 0,
                y: 0,
                enable_date: true,
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                items: [],
                filtered_items: [],
                status_form: 0,
                origin_loads: [],
                discharge_places: [],
                load_types: [],
                trucks: [],
                start_selected_origin_load: null,
                start_selected_discharge_place: null,
                start_selected_load_type: null,
                start_selected_truck: null,
                start_date: null,
                end_date: null,
                open_context_menu_dialog:false,
                selected_item_for_context_menu:null,
                selected_barname: '',
                selected_tonaje: '',
                selected_tonaje_decimal: '',
                headers: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },
                    {
                        text: 'تاریخ',
                        value: 'doc_date_persian'
                    },
                    {
                        text: 'شماره بارنامه',
                        value: 'barname'
                    },

                    {
                        text: 'نام کامیون',
                        value: 'truck_name'
                    },
                    {
                        text: 'نوع جنس',
                        value: 'load_type'
                    },
                    {
                        text: 'مبدا بارگیری',
                        value: 'origin_load'
                    },
                    {
                        text: 'محل تخلیه',
                        value: 'discharge_place'
                    },

                    {
                        text: 'تناژ',
                        value: 'tonaje'
                    },

                    {
                        text: 'مبلغ کارفرما',
                        value: 'calculated_employer_price'
                    },
                    {
                        text: 'مبلغ کامیوندار',
                        value: 'calculated_driver_price'
                    },


                    {
                        text: '',
                        value: 'operation'
                    },
                ],

                normalizer_origin(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
                normalizer_load_type(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
                normalizer_discharge_place(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
            }
        },
        mounted() {
            // this.get_data()
            this.get_origin_downloads()
            this.get_load_types()
            this.get_discharge_places()
            this.get_trucks()
            this.start_date = this.miladi_to_jalali(this.get_today())
            this.end_date = this.miladi_to_jalali(this.get_today())

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item()

                } else {
                    this.status_form = 0
                }
            })
        },
        watch: {


            // start_date: function () {
            //     this.get_data()
            // },
            // end_date: function () {
            //     this.get_data()
            // },
            start_selected_origin_load: function () {
                this.filter_data()
            },
            start_selected_discharge_place: function () {
                this.filter_data()
            },
            start_selected_load_type: function () {
                this.filter_data()
            },
            start_selected_truck: function () {
                this.filter_data()
            },
            date: function () {
                this.filter_data()
            },
            selected_barname: function () {
                this.filter_data()
            },
            selected_tonaje: function () {
                this.filter_data()
            },
            selected_tonaje_decimal: function () {
                this.filter_data()
            },

        },
        methods: {
            open_context_menu(e, item){
                e.preventDefault()
                this.open_context_menu_dialog = false;

                this.x = e.clientX
                this.y = e.clientY

                this.open_context_menu_dialog = true;
                this.selected_item_for_context_menu = item
                this.$nextTick(() => {
                    this.open_context_menu_dialog = true
                })
                console.log(item)
            },
            real_paying_driver(item) {

                var price = item.driver_price
                var tonaje = parseFloat(item.tonaje)
                if (item.tonaje_limit == 1) {
                    if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return (parseFloat(price) * tonaje)
            },
            deliver_employer(item) {

                var price = item.employer_price
                var tonaje = parseFloat(item.tonaje)
                if (item.tonaje_limit == 1) {
                    if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return (parseFloat(price) * tonaje)

            },

            filter_data() {
                console.log('filter_called')
                this.filtered_items = this.items
                if (this.start_selected_discharge_place != null) {
                    this.filtered_items = this.filtered_items.filter(x => x.discharge_place_id == this.start_selected_discharge_place)
                }
                // if (this.end_selected_discharge_place != null) {
                //     this.filtered_items = this.filtered_items.filter(x => x.discharge_place_code <= this.end_selected_discharge_place)
                // }

                if (this.start_selected_load_type != null) {
                    this.filtered_items = this.filtered_items.filter(x => x.load_type_id == this.start_selected_load_type)
                }

                if (this.start_selected_origin_load != null) {
                    this.filtered_items = this.filtered_items.filter(x => x.origin_load_id == this.start_selected_origin_load)
                }
                if (this.start_selected_truck != null) {
                    console.log("filter truck", this.start_selected_truck)
                    this.filtered_items = this.filtered_items.filter(x => x.truck_id == this.start_selected_truck)
                }
                if (this.selected_barname != null) {
                    this.filtered_items = this.filtered_items.filter(x => x.barname.includes(this.selected_barname))
                }
                if (this.selected_tonaje != null && this.selected_tonaje != "") {
                    var new_tonaje = "";
                    if (this.selected_tonaje_decimal != "" && this.selected_tonaje_decimal != null) {
                        new_tonaje = this.selected_tonaje + "." + this.selected_tonaje_decimal
                    }
                    // this.filtered_items = this.filtered_items.filter(x => x.tonaje==new_tonaje)
                    this.filtered_items = this.filtered_items.filter(x => x.tonaje.includes(new_tonaje))
                }


            },
            get_data() {
//                 if(!this.enable_date && this.selected_barname==""){
//                     this.$root.modal_component.show_warning_notif('شماره بارنامه را وارد کنید')
// return
//                 }
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))
                formData.append('enable_date', this.enable_date)
                formData.append('barname', this.selected_barname)
                this.axios.post('/api/delivery_document/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items = response.data.data.map((item, row_id) => {
                            return {...item, row_id}
                        }),

                            self.items.forEach(function (val) {
                                val.calculated_driver_price = self.real_paying_driver(val)
                                val.calculated_employer_price = self.deliver_employer(val)
                                val.tonaje = parseFloat(val.tonaje).toFixed(3)
                            })
                        self.filtered_items = response.data.data
                        self.filter_data()
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_origin_downloads() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/origin/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.origin_loads = response.data.data
                      self.origin_loads.sort((a, b) => a.code.localeCompare(b.code, undefined, {numeric: true, sensitivity: 'base'}));

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_load_types() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/load_type/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.load_types = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    console.log(error)
                })

            },
            get_discharge_places() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/discharge_places/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.discharge_places = response.data.data
                      self.discharge_places.sort((a, b) => a.code.localeCompare(b.code, undefined, {numeric: true, sensitivity: 'base'}));

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_trucks() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/trucks/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.trucks = response.data.data
                        self.trucks.sort((a, b) => a.code.localeCompare(b.code, undefined, {numeric: true, sensitivity: 'base'}));

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            edit_item(item) {
                if(item==null){
                    item = this.selected_item_for_context_menu
                }
                this.$router.push({path: "/edit-delivery-document/" + item.id})
            },
            delete_item_dialog(item) {
                console.log("item id",item.id)
                if(item==null){
                    item = this.selected_item_for_context_menu
                }

                this.$root.modal_component.show_confirm_modal('هشدار', 'آیا مایل به حذف این ردیف هستید؟', ['تایید'], this.confirm_delete_name)
                this.status_form = item.id
                console.log("item id for delete",this.status_form,item)
            },
            delete_item() {
                const self = this
                const formData = new FormData()
                console.log("delete item",this.status_form);
                const url = '/api/delivery_document/delete'
                formData.append('id', this.status_form)

                this.axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res)
                    self.status_form = 0

                    self.get_data()

                })
                    .catch(function (error) {
                        console.log(error)
                    })
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

        }
    }
</script>
